/**
 * Format booking ID to short reference for display
 * Example: "a55f9bc0-0257-405a-9ac6-1a12a529f045" -> "#a55f9bc0"
 */
export const formatBookingReference = (bookingId) => {
  if (!bookingId) return 'N/A';
  const shortId = bookingId.split('-')[0];
  return `#${shortId}`;
};

/**
 * Format payment method for display.
 *
 * Pocket Pay variants share the `pocket_pay_` prefix so server-side code
 * can detect "is this a Pocket Pay charge?" via `.startsWith()` without
 * caring which mode the customer picked.
 */
export const formatPaymentMethod = (paymentMethod) => {
  if (!paymentMethod) return 'Pending';

  const methodMap = {
    'pocket_pay_card': 'Card',
    'pocket_pay_qr': 'QR',
    'pocket_pay_biller': 'Biller',
    'card': 'Card',
    'cash': 'Cash',
    'online_banking': 'Online Banking',
    'wallet': 'E-Wallet'
  };

  return methodMap[paymentMethod] || paymentMethod;
};

/**
 * Get payment method badge color
 */
export const getPaymentMethodColor = (paymentMethod) => {
  const colorMap = {
    'pocket_pay_card': 'blue',
    'pocket_pay_qr': 'green',
    'pocket_pay_biller': 'purple',
    'card': 'blue',
    'cash': 'green',
    'online_banking': 'purple',
    'wallet': 'orange'
  };

  return colorMap[paymentMethod] || 'gray';
};
